import React, { useState } from 'react';
import { Form, Button, Radio, Modal } from 'antd';
import { MaskedInput } from 'antd-mask-input';
import QrScan from 'react-qr-reader'
import { useHistory } from 'react-router-dom';

import Card from '../../../components/Card';
import PageHeader from '../../../components/PageHeader';

import handleInternalServerError from '../../../utils/handleInternalServerError';

import api from '../../../services/api';
import { useLocation } from '../../../hooks/location';

const BookingValidation = () => {
    const [form] = Form.useForm();
    const { location, storage } = useLocation()
    const [searchFor, setSearchFor] = useState('qr');
    const [searchForText, setSearchForText] = useState('QR Code');
    const history = useHistory();
    const [qrscan, setQrscan] = useState('No result');
    const { scheduledService } = location

    const bookingValidation = async (type, value) => {
        try {
            const { data } = await api.get(`bookings?type=${type || 'cpf'}&value=${value}`)

            data.scheduledServiceId = scheduledService.id

            storage({ booking: data })
            history.push('searched-booking')
        } catch (err) {
            if (err?.response?.status === 404) {
                Modal.error({
                    title: `Não existe nenhuma reserva com este ${searchFor}`
                })
            } else {
                handleInternalServerError()
            }
        }
    }

    const handleValidationClick = async () => {
        const { type, field } = form.getFieldsValue()

        if (!field) {
            Modal.warning({ title: `O campo ${searchFor} é obrigatório` })
            return false
        }

        let value = field;
        if (!type || type === 'cpf') {
            value = field.replace(/[^\d]+/g, '')
        }

        if (type === 'code') {
            value = field.replace(/\s/g, '').replace(/_/g, '')
            if (value.length !== 8) {
                Modal.warning({ title: 'Código inválido' })
                return false
            }
        }

        bookingValidation(type, value)
    }

    const handleChangeType = (e) => {
        form.setFieldsValue({ field: '' })
        setSearchFor(e.target.value)
        setSearchForText(e.target.title)
    }

    const handleScan = data => {
        if (!data || data === qrscan) {
            return false
        }
        setQrscan(data)
        bookingValidation('code', data)
    }
    const handleError = err => {
        console.error(err)
    }

    const inputs = {
        cpf: <MaskedInput mask="111.111.111-11" autoComplete="off" />,
        code: <MaskedInput mask="** ** ** **" autoComplete="off" />,
        qr: <QrScan
            delay={300}
            onError={handleError}
            onScan={handleScan}
            style={{ height: 240, width: 320 }}
        />
    }

    return (
        <>
            <PageHeader title="Consultar reserva" admin />
            <div className="app-wrapper">
                <Card>
                    <Form
                        layout="vertical"
                        form={form}
                    >
                        <Form.Item label="Consultar por" name="type">
                            <Radio.Group className="custom-radio-button" onChange={handleChangeType} defaultValue="qr">
                                <Radio.Button title="QR Code" value="qr">QR Code</Radio.Button>
                                <Radio.Button title="CPF" value="cpf">CPF</Radio.Button>
                                <Radio.Button title="Código" value="code">Código</Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item label={`Insira o ${searchForText}`} name="field">
                            {inputs[searchFor]}
                        </Form.Item>
                    </Form>
                </Card>

                {
                    searchFor !== 'qr' ?
                        <div className="btn-container">
                            <Button type="primary" shape="round" onClick={handleValidationClick}>Validar</Button>
                        </div> : null
                }
            </div>
        </>
    )
}

export default BookingValidation;